jQuery(document).foundation();

jQuery(function($) {

  function setHeaderSizeVar() {
    var marginTop = $('header').outerHeight();
    var $mobileSubmenuHeader = $('.mobile-sub-menu-header');
    var $submenuHeader = $('.sub-menu-header');
    if ($mobileSubmenuHeader.length > 0) {
      marginTop += $mobileSubmenuHeader.outerHeight();
    }
    if ($submenuHeader.length > 0) {
      marginTop += $submenuHeader.outerHeight();
    }
    $('body').css('--header-height',marginTop+'px');
  }
  
    // mobile fix for taps
  // FastClick.attach(document.body);

  setHeaderSizeVar();

	// mobile image tile slider
	var $imageTilesSlider = $('.image-tiles-carousel');
	if ($imageTilesSlider.length > 0 && $imageTilesSlider.is(':visible')) {
		$imageTilesSlider.flickity({
			cellSelector: '.tile-item',
			pageDots: false,
			prevNextButtons: true,
		});
	}

  // skip hero
  if ($('.hero.skip-hero').length > 0) {
    var heroOffset = $('.hero').offset().top + $('.hero').outerHeight() + 20;
    $('html, body').stop().animate({scrollTop: heroOffset}, 0);
  }

  // top-image-text column click
  $('.top-image-text .column').on('click', function() {
    window.location = $(this).find('a').attr('href');
  });

  // back to top arrow
  $('.back-to-top span').on('click', function() {
    $('html, body').stop().animate({scrollTop: 0}, 500);
  });

  // gallery
  $('.gallery-lightbox .carousel-main').flickity({
    cellSelector: '.carousel-cell',
    setGallerySize: false,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: { 
      x0: 20,
      x1: 60, y1: 40,
      x2: 65, y2: 35,
      x3: 30
    },
  });

  $('.gallery-lightbox .carousel-nav').flickity({
    cellSelector: '.carousel-cell',
    setGallerySize: false,
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    groupCells: true,
    on: {
      ready: function() {
        $('.gallery-lightbox .carousel-nav').each(function(){
          var navItemW = 0;
          var $carNav = $(this).find('.flickity-viewport');
      
          $carNav.find('.carousel-cell').each(function(){
            navItemW += $(this).outerWidth();
          })
      
          if (navItemW < ($carNav.width() - 60)) {      
            $(this).closest('.gallery-container').find('.next-previous').addClass('hide');
          } 
        })
      },
    }
  });

  var $carouselMain = $('.gallery-lightbox .carousel-main').flickity();
  $carouselMain.on('select.flickity', function() {
    $('.gallery-lightbox .carousel-nav').find('.carousel-cell').removeClass('carousel-cell--active').eq($carouselMain.data('flickity').selectedIndex).addClass('carousel-cell--active');
  });

  $('.gallery-lightbox .previous-large').on('click', function() {
    $('.gallery-lightbox .carousel-main').flickity('previous');
  });

  $('.gallery-lightbox .next-large').on('click', function() {
    $('.gallery-lightbox .carousel-main').flickity('next');
  });

  $('.gallery-lightbox .previous').on('click', function() {
    $('.gallery-lightbox .carousel-nav').flickity('previous');
  });

  $('.gallery-lightbox .next').on('click', function() {
    $('.gallery-lightbox .carousel-nav').flickity('next');
  });

  $('.gallery:not(.zoomless) .thumbnail').on('click', function() {
    var openURL = $(this).closest('.thumbnail').data('open-url');
    if (openURL) {
      window.location.href = openURL;
    } else {
      $('.gallery-lightbox .carousel-main').flickity('select', $(this).index());
      $('.gallery-lightbox .carousel-nav').flickity('select', $(this).index());
      setTimeout(function() {
        $('.gallery-lightbox').addClass('gallery-lightbox--is-showing');
        $('.gallery-lightbox .carousel-main').focus();
      }, 800);  
    }
  });

  $(document).keyup(function(e) {
    if (e.key === "Escape") { 
      if ($('.gallery-lightbox.gallery-lightbox--is-showing').length > 0) {
        $('.gallery-lightbox').removeClass('gallery-lightbox--is-showing');
      }
    } 
  });
  
  $('.gallery-lightbox .carousel-nav').on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
    $('.gallery-lightbox .carousel-main').flickity('select', cellIndex);
  });

  $('.gallery-lightbox .close').on('click', function() {
    $('.gallery-lightbox').removeClass('gallery-lightbox--is-showing');
  });

  $('.gallery h4').on('click', function() {
    $('.gallery').toggleClass('gallery--is-showing-all');
    if ($('.gallery').hasClass('gallery--is-showing-all') == false) {
      $('html, body').stop().animate({scrollTop: $('.gallery .more').offset().top - 200}, 0);
    }
  });

  $('.white-box p.toggle .english').on('click', function(){
    $('.white-box .spanish').removeClass('active');
    $('.white-box .english').addClass('active');
  });

  $('.white-box p.toggle .spanish').on('click', function(){
    $('.white-box .english').removeClass('active');
    $('.white-box .spanish').addClass('active');
  });

  // carousel mobile
  $('.carousel-mobile').flickity({
    setGallerySize: true,
    imagesLoaded: true,
    pageDots: true,
    prevNextButtons: false
  });

  // hero carousel
  $('.hero-carousel').flickity({
    setGallerySize: true,
    imagesLoaded: true,
    pageDots: true,
    autoPlay: 2500,
    prevNextButtons: true,
    wrapAround: true,
    fade: true,
    arrowShape: { 
      x0: 20,
      x1: 60, y1: 40,
      x2: 65, y2: 35,
      x3: 30
    },
  });

  $(".menu-main-navigation .menu-item").hover(function(){
      var id = this.getAttribute('data-item-id');
      var selectedSubItem = '[data-sub-item='+id+']';
      $(selectedSubItem).addClass('showing'); 
    }, function(){
      var id = this.getAttribute('data-item-id');
      var selectedSubItem = '[data-sub-item='+id+']';
      $(selectedSubItem).removeClass('showing');
  });

  $(".sub-menu .showing").hover(function(){
    }, function(){
      $(this).removeClass('showing');
  });

  $('a[href="#"]').on('click', function(e) {
    e.preventDefault();
  });

  $(".tnh-main-mobile-nav-holder .mobile-menu-toggle").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass('opened');
    $('.mobile-menu-panel').toggleClass('opened');
    $("#search-panel").removeClass('is-shown');
  }); 

  var $fktyMain = $('.carousel-prod-main').flickity({
    cellSelector: '.carousel-prod-cell',
    cellAlign: 'left',
    draggable: true,
    pageDots: false,
    fade: true,
    prevNextButtons: true,
    arrowShape: { 
      x0: 10,
      x1: 55, y1: 45,
      x2: 60, y2: 40,
      x3: 20
    },
  });

  $('.carousel-prod-nav').flickity({
    cellSelector: '.carousel-prod-cell',
    asNavFor: '.carousel-prod-main',
    cellAlign: 'left', 
    pageDots: false,
    draggable: false,
    prevNextButtons: false,
    contain: true, 
    on: {
      settle: function( index ) {
        var flickMain   = $fktyMain.data('flickity');
        var $activeCell = null;  
        if (flickMain.slides) {
          $(flickMain.slides).each(function(i,e){
            let $el = $(this.cells[0].element);
            let vid = $el.find('video');
            if (vid.length > 0) {
              vid.get(0).pause();
            }
            if (i == index) {
              $activeCell = $el; 
            }
          });
        }

        if ($activeCell) {
          let vid = $activeCell.find('video');
          if (vid.length > 0) {
            vid.get(0).play();
          }
        
        }
      }
    }
  });

  // on scroll change header class
  if ($('header.scroll-change').length > 0) {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > $(window).height() / 5) {
        $('header').removeClass('transparent');
        $('.trees-bar').addClass('trees-bar--is-showing');
      } else {
        $('header').addClass('transparent');
        $('.trees-bar').removeClass('trees-bar--is-showing');
      }
    });
  } else {
    $(window).on('scroll', function() {
      if ($(window).scrollTop() > $(window).height() / 3) {
        $('header').addClass('transparent');
        $('.sub-menu-header.show-for-large, .mobile-sub-menu-header').addClass('to-the-top');
      } else {
        $('header').removeClass('transparent');
        $('.sub-menu-header.show-for-large, .mobile-sub-menu-header').removeClass('to-the-top');
      }
    });  
  }

  // search panel
  var $searchPanel = $("#search-panel");
  $('.search-menu-icon').on('click', function(e) {
    e.preventDefault();
    $(".tnh-main-mobile-nav-holder .mobile-menu-toggle").removeClass('opened');
    $('.mobile-menu-panel').removeClass('opened');

    if ($searchPanel.is('.is-shown')) {
      $searchPanel.removeClass('is-shown');
    } else {
      $searchPanel.addClass('is-shown');
    }
  });
  $searchPanel.find('.button-back').on("click", function(e) {
    e.preventDefault();
    $searchPanel.removeClass('is-shown');
  });

  // faq toggle
  $('.faq .faq-item .question').on('click', function() {
    var $faqItem = $(this).parent();
    $faqItem.toggleClass('faq-item--is-open');
    $faqItem.find('.answer').slideToggle(300);
  });

  // newsletter popup
  $('a').on('click', function(e) {
    if ($(this).attr('href') == '#newsletter' || $(this).attr('href').indexOf('newsletter=1') > -1) {
      e.preventDefault();
      $('#newsletter-popup-overlay').foundation('open');
    }
  });


  // back button
  $(".back-button").on("click", function(e) {
    e.preventDefault();
    history.back();
		return false;
  });

  // share icon sharing
  $('.hero .share a').on('click', function(e) {
    var network = $(this).attr('class');
    var shareUrl = encodeURI(window.location.href);
    if (network == 'facebook') {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + shareUrl);
    }
    else if (network == 'twitter') {
      var shareText = $('title').text();
      window.open('https://twitter.com/share?text=' + encodeURIComponent(shareText) + '&url=' + shareUrl);
    }
    else if (network == 'linkedin') {
      window.open('https://www.linkedin.com/shareArticle?title=&summary=&source=&url=' + shareUrl)
    }
    else if (network == 'email') {
      window.open('mailto:?body=' + shareUrl)
    }
    e.preventDefault();
  });

  // trees popup
  if ($('.front').length > 0) {
    $('.trees-bar').addClass('trees-bar--is-showing');
    if (Cookies.get('trees_popup_is_closed')) {
      $('.trees-bar').addClass('trees-bar--is-showing');
    } else {
      $('.trees-popup-overlay').addClass('trees-popup-overlay--is-showing');
      Cookies.set('trees_popup_is_closed', '1', { path: '/' });
    }
  }

  $('.trees-popup-overlay .close').on('click', function() {
    $('.trees-popup-overlay').removeClass('trees-popup-overlay--is-showing');
    $('.trees-bar').addClass('trees-bar--is-showing');
  });

	$(window).on("resize", function() {
    setHeaderSizeVar();
	});

  var hash = window.location.hash;
  if (hash && hash.indexOf('image-text-') > -1) {
    var index = parseInt(hash.replace('#image-text-', ''));
    var offsetTop = $('.image-text').eq(index).offset().top - $('header').height();
    $('html, body').stop().animate({scrollTop: offsetTop}, 0);
  }

  // on product category pages, scroll down straight to title
  /*
  var $shopCategIntro = $('.shop-category-intro.must-scroll');
  if ($shopCategIntro.length > 0) {
    var offsetTop = $shopCategIntro.eq(0).next().offset().top - $('header').height();
    $('html, body').stop().animate({scrollTop: offsetTop}, 0);
  }
  */

});
